<template lang="pug">
  v-container(fluid)
    h2.text-center {{translations.title}}

    v-row.px-md-10.pb-10( justify="center")
      v-col(cols="12")
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        )
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items"  :key="'item'+ind")
                td {{ item.name }}
                td {{ item.email }}
                td {{ item.rol }}
                //- td
                  ProviderInfoDialog(:buttonText="translations.button")
                td(v-if="hasPermission('views.administrators.editAdministrator')")
                  BaseDialog(type="edit", :title="translationsForm.title.edit+item.name" v-slot="{close, opened}")
                    AdministratorEdit(@successEdit="updateAdministrators(opened,close)", :clearForm="opened", :user="item", :operatorsListAll="operatorsListAll", :translations="translationsForm")
    BaseDialog(v-if="hasPermission('views.administrators.createAdministrator')" type="create", :title="translationsForm.title.create" v-slot="{close, opened}")
      AdministratorCreate(@successCreate="updateAdministrators(opened,close)", :clearForm="opened", :operatorsListAll="operatorsListAll", :translations="translationsForm")
</template>

<script>

  import AdministratorCreate from '@/components/forms/AdministratorCreate';
  import AdministratorEdit from '@/components/forms/AdministratorEdit';

  export default {
    name: "AdministratorsIndex",
    components: {
      AdministratorCreate,
      AdministratorEdit,
    },
    computed: {
      translations() {
        return this.$t("views.adminIndex");
      },
      translationsForm(){
        return this.$t("forms.administrator");
      },
      headers() {
        let headers = [
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.email,
            value: 'email'
          },
          {
            text: this.translations.tableHeadText.rol,
            value: 'rol'
          },
        ];
        if(this.hasPermission('views.administrators.editAdministrator')){
          headers.push(
            {
              text: '',
              value: 'edit',
              sortable: false
            });
        }
        return headers;
      },
      datos(){
        return this.administratorsListAll.map(admin =>{
          return {
            _id: admin.id,
            name: admin.name,
            email: admin.email,
            phone: admin.phone != undefined ? admin.phone : '',
            rol: admin.rol,
            bookmaker: {
              name: admin.bookmaker ? admin.bookmaker.n : '',
              id: admin.bookmaker ? admin.bookmaker._id : ''
            }
          }
        })
      },
      administratorsListAll() {
        return this.$store.state.administrators;
      },
      operatorsListAll(){
        return this.$store.state.operators.map(operator => {
          return{
            text: operator.n,
            value: operator._id
          }
        })
      },
    },
    created() {
      this.$store.dispatch('getAdministrators');
      this.$store.dispatch('getOperators');
    },
    methods: {
      updateAdministrators(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getAdministrators');
        }
      }
    }
  }
</script>

<style lang="sass">
</style>